const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.WorkoutServiceSimpleClient = function WorkoutServiceSimpleClient(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options["format"] = "text";

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
  this.credentials_ = credentials;
  this.options_ = options;

  this.listWorkouts = this.listWorkouts.bind(this);
};
const methodInfo_WorkoutService_ListWorkouts = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.WorkoutService/ListWorkouts",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListWorkoutsRequest,
  imports.stronachgroup.first.racehorse360.ListWorkoutsResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListWorkoutsResponse.decode
);
module.exports.WorkoutServiceSimpleClient.prototype.listWorkouts = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListWorkoutsRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.WorkoutService/ListWorkouts",
    message,
    metadata || {},
    methodInfo_WorkoutService_ListWorkouts
  );
};
